// extracted by mini-css-extract-plugin
export default {"headerDashboard":"HeaderWelcome_headerDashboard__vRUrd"};